<template>
  <base-table-collapse
    :headColumns="cols"
    :rows="rows"
  />
</template>

<script>
import { digValueInObject } from '../../helpers'

export default {
  name: 'ReportInventoryTable',

  props: ['items', 'columnNames', 'pickKeys'],

  computed: {
    cols () {
      return [
        {
          style: null,
          text: this.$t('message.item'),
        },
        ...this.columnNames,
      ]
    },
    rows () {
      return this.items.map((item) => {
        const subKeys = item.skus || item.items
        return [
          {
            head: {
              text: item.date,
            },
            body: subKeys.reduce((acc, cur) => {
              return acc.push({ text: cur.info.fieldName }) && acc
            }, []),
          },
          ...(
            (() => {
              return this.pickKeys.map((key) => {
                return {
                  head: {
                    text: this.getNumber(digValueInObject(key, item)),
                  },
                  body: subKeys.reduce((acc, cur) => {
                    return acc.push({ text: this.getNumber(digValueInObject(key, cur)) }) && acc
                  }, []),
                }
              })
            })()
          ),
        ]
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/combine/ReportGeneralTable.vue